import List from './list.vue'
import ListItem from './list-item.vue'
import ListItemMeta from './list-item-meta.vue'

List.Item = ListItem
List.Item.Meta = ListItemMeta

export default List
